export class TipoUnidadeModel {
  id: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/tipo-unidade.model.ts